import React from 'react'

export const Titles = ({ text = 'Sign up as an event organizer' }) => (
  <>
    <div className="get-started-label">{text}</div>
    <div className="instruction-label">Let's get you started</div>

    <div className="existing-client-prompt">
        Already have your brand or events set up?{' '}
        <a href="/login" className="login-link">
          Log in here
        </a>
      </div>
  </>
)
